import { useTheme } from '@mui/material';
import { FieldRenderBlockProp } from '../..';
import ListAvatarBlock from '../../_utils/list-avatar-block';

export default function SkypeBlockRenderer(props: FieldRenderBlockProp) {
  const theme = useTheme();

  if (!props.data?.skype) return <></>;

  return (
    <ListAvatarBlock
      title={props.data.skype?.title}
      value={props.data.skype?.value}
      e={props}
    />
  );
}
